export default __webpack_public_path__ + "static/media/dinner4.840c360b.png";